module.exports = __webpack_public_path__ + "09bd252.webp";